import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportingService {
  constructor(private http: Http) {}

  baseurl = environment.apiBaseUrl;

  fetchReportData(data) {
    return this.http
      .post(`${this.baseurl}/reporting/fetchReportData`, { data })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/reporting.service.ts